// removed by extract-text-webpack-plugin
module.exports = {"nf-edit-tool":"nf-edit-tool","nf-edit-tool__header":"nf-edit-tool__header"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/EditInventoryManagement/EditInventoryManagement.scss
// module id = 5580
// module chunks = 1